/** Drop auth-flow telemetry, including URLs embedded in navigation breadcrumbs. */
export function containsDesktopAuthData(value: unknown, seen = new WeakSet<object>()): boolean {
  if (typeof value === "string") {
    return /(?:\/desktop\/authorize|\/api\/desktop-auth\/|http:\/\/127\.0\.0\.1:\d+\/callback)/i.test(value);
  }
  if (!value || typeof value !== "object" || seen.has(value)) return false;
  seen.add(value);
  return Object.values(value).some(child => containsDesktopAuthData(child, seen));
}
